import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

interface UnsavedChangesLeaveDialogProps {
    show: boolean;
    isLoading?: boolean;
    onClose: () => void;
    onLeaveWithoutSaving: () => void;
    onSave: () => void;
}

const UnsavedChangesLeaveDialog = ({
    show,
    isLoading = false,
    onClose,
    onLeaveWithoutSaving,
    onSave,
}: UnsavedChangesLeaveDialogProps) => {
    const intl = useIntl();

    return (
        <Dialog
            show={show}
            title={(
                <>
                    <span className="rioglyph rioglyph-warning-sign margin-right-10 text-color-warning" />
                    <span>{intl.formatMessage({ id: "intl-msg:tas.occurrence.leave-unsaved.title" })}</span>
                </>
            )}
            body={intl.formatMessage({ id: "intl-msg:tas.occurrence.leave-unsaved.body" })}
            bsSize={Dialog.SIZE_SM}
            onClose={onClose}
            footer={(
                <div className="display-flex justify-content-end">
                    <Button
                        bsStyle="default"
                        className="margin-right-10"
                        onClick={onLeaveWithoutSaving}
                        disabled={isLoading}
                    >
                        {intl.formatMessage({ id: "intl-msg:tas.occurrence.leave-unsaved.btn-close-without-save" })}
                    </Button>
                    <Button
                        bsStyle="primary"
                        onClick={onSave}
                        disabled={isLoading}
                        className={isLoading ? "btn-loading disabled" : ""}
                    >
                        {intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-save" })}
                    </Button>
                </div>
            )}
        />
    );
};

export default UnsavedChangesLeaveDialog;
